import { Component, ElementRef, OnInit, ViewChild, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { AccountService } from '../services/account.service';
import { HttpErrorResponse } from '@angular/common/http';
import { DashboardService } from '../services/dashboard.service';
import { environment } from '../../environments/environment';
import { OAuthService } from 'angular-oauth2-oidc';
import { Helper } from '../helpers/helper';
import { NgbAccordionModule, NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { FormBuilder, ReactiveFormsModule, Validators } from '@angular/forms';
import { UserService } from '../services/user.service';
import { SessionService } from '../services/active-session-management.service';
import { Enum } from '../helpers/enums/enum';
import { CommunicationService } from '../services/communication.service';
import * as $ from 'jquery';
import { CookieService } from 'ngx-cookie-service';
import { NudgeService } from '../services/nudge.service';
import { CommonModule } from '@angular/common';
import { CurrencyMaskDirective } from '../helpers/directive/currency-mask.directive';
import { PriorityTopBannerComponent } from '../shared-component/priority-top-banner/priority-top-banner.component';

@Component({
  selector: 'app-account',
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  templateUrl: './account.component.html',
  host: { 'class': 'd-flex flex-column h-100 register-bg' },
  styleUrls: ['./account.component.css'],
  standalone: true,
  imports: [CommonModule,ReactiveFormsModule, NgbAccordionModule, CurrencyMaskDirective,PriorityTopBannerComponent]
})
export class AccountComponent implements OnInit {

  @ViewChild('updateIncomeModel', { static: false }) updateIncomeModel: ElementRef;
  @ViewChild('callbackSuccessModel', { static: false }) callbackSuccessModel: ElementRef;
  @ViewChild('callbackErrorModel', { static: false }) callbackErrorModel: ElementRef;
  @ViewChild('callbackConfirmationModel', { static: false }) callbackConfirmationModel: ElementRef;
  modalOptions: NgbModalOptions;

  accountData: any = {};
  otherAccountsData: any = {};
  showMore = {
    accountsSummary: false,
    judgmentInfo: false,
    debtRestructure: false,
    previousSearchInfo: false,
    propertyInfo: false
  };
  creditReportYear; creditReportMonth;
  isDataAvailable: true;
  creditHealthInfo: {
    grossIncome: '',
    totalCurrentBalance: '',
    totalMonthlyInstalments: ''
  };
  env = environment;
  updatedDate = '';
  updateIncomeForm;
  updateIncomeErrorMsg = '';
  UpdateIncomeDisabled = true;

  callBackErrorDebt = 'Please try after 15 minutes.';
  closeCallMeBackPopupButtonName: string = "CallMeBackPopupButtonClosed"
  callbackErrorMsg = '';
  callbackSuccessMsg = '';
  campaignSourceType = 8;
  UserGeminiNumber = ""
  isDcCtaVisible = false;
  debtToIncomeData: any;
  dcCtaButtonText = "Consolidate your accounts";
  productsQualifyResponse:any;
  pageName:string ='account'

  constructor(
    private accountService: AccountService,
    private dashboardService: DashboardService,
    private oauthService: OAuthService,
    private helper: Helper,
    private formBuilder: FormBuilder,
    private modalService: NgbModal,
    private userService: UserService,
    private sessionService: SessionService,
    private communicationService: CommunicationService,    
    private cookieService: CookieService,
    private nudgeService: NudgeService,

  ) { }

  ngOnInit() {

    sessionStorage.setItem('isNavfromNudgeClicked', 'false');

   
    this.sessionService.checkActiveSession();
    this.creditReportYear = new Date().getFullYear();
    this.creditReportMonth = new Date().getMonth() + 1;
    this.accounts();
    this.getCreditHealthInfo();
    this.getCreditHistory();

    this.getProductsQualify();

    window.scroll({ top: 0, left: 0, behavior: 'smooth' });
    var date = new Date();
    var hour = date.getUTCHours() + 2;
    var day = date.getDay();
    var minutes = date.getUTCMinutes();
    if (day == 1 || day == 2 || day == 3 || day == 4) {
      if (hour == 8 && minutes >= 30) {
        this.createChat();
      }
      if (hour >= 8 && hour <= 17) {
        this.createChat();
      }
    }
    if (day == 5) {
      if (hour == 8 && minutes >= 30) {
        this.createChat();
      }
      if (hour >= 8 && hour <= 16) {
        this.createChat();
      }
    }

    this.updateIncomeForm = this.formBuilder.group({
      GrossIncome: ['', [Validators.required, Validators.min(0)]],
    });

  }
  get updateIncomeFormControls() { return this.updateIncomeForm.controls; }

  //#region  Accounts
  accounts() {

    var accountsData = sessionStorage.getItem('accounts');

    if (accountsData != null) {
      this.BindAccounts(JSON.parse(accountsData));
      return;
    }

    this.accountService.accounts().subscribe({
        next: (data: any) => {
      this.BindAccounts(data);
      sessionStorage.setItem('accounts', JSON.stringify(data));
    }, error: (err: HttpErrorResponse) => { }});
  }

  private BindAccounts(data: any) {
    this.accountData = data?.accountInformation;
    this.otherAccountsData = data?.otherAccounts;
  }

  //#endregion Accounts


  getCreditHistory() {

    var loadCreditHistoryData = sessionStorage.getItem('loadCreditHistory');
    if (loadCreditHistoryData != null) {
      var data = JSON.parse(loadCreditHistoryData);
      this.isDataAvailable = data.isDataAvailable;
      this.updatedDate = data.createdDate;
      return;
    }

    const param = { Year: this.creditReportYear, Month: this.creditReportMonth };
    this.dashboardService.creditHistory(param).subscribe({
        next: (data: any) => {
      this.isDataAvailable = data.isDataAvailable;
      this.updatedDate = data.createdDate;
    }, error: (err: HttpErrorResponse) => { }});
  }

  getCreditHealthInfo() {

    var loadData = sessionStorage.getItem('load');
    var loadCreditHealthInfoData = sessionStorage.getItem('loadAccountCreditHealthInfo');
    if (loadCreditHealthInfoData != null) {
      var data = JSON.parse(loadCreditHealthInfoData);
      this.creditHealthInfo = data?.creditHealthInfo;
      return;
    }

    const param = { Year: this.creditReportYear, Month: this.creditReportMonth };
    this.dashboardService.creditHealthInfo(param).subscribe({
        next: (data: any) => {
      if (data != null) {
        sessionStorage.removeItem('loadAccountCreditHealthInfo');
        sessionStorage.setItem('loadAccountCreditHealthInfo', JSON.stringify(data));
        this.creditHealthInfo = data.creditHealthInfo;
      }
    }, error: (err: HttpErrorResponse) => { }});
  }

  scrollToElement(id: any): void {
    const element = document.getElementById(id);
    if (element != null) {
      const offset = 100;
      const bodyRect = document.body.getBoundingClientRect().top;
      const elementRect = element.getBoundingClientRect().top;
      const elementPosition = elementRect - bodyRect;
      const offsetPosition = elementPosition - offset;

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  }
  createChat() {
    if (!environment.hideChat) {
      if ((window as any).fcWidget) {
        var userData = this.oauthService.getIdentityClaims();

        if(userData==null && localStorage.getItem('apiUserModel')!=null) {
          userData = JSON.parse(localStorage.getItem('apiUserModel'));
        }
        (window as any).fcWidget.init({
          token: this.env.freshChatToken,
          host: this.env.freshChatHost,
          tags: ["JustMoney"],
          externalId: userData['name'],     // user’s id unique to your system
          firstName: userData['given_name'],              // user’s first name
          lastName: userData['family_name']
        });
      }
      setTimeout(() => {
        const launcher = document.getElementById("fc_widget");
        const chatFrame = document.getElementById("fc_frame");

        if (launcher) launcher.style.zIndex = "600"; // lower value
        if (chatFrame) chatFrame.style.zIndex = "600";
      }, 2000);
    }
  }

  showUpdateIncomeModel() {
    if (this.isDataAvailable) {
      this.UpdateIncomeDisabled = true;
      this.updateIncomeForm.patchValue({
        GrossIncome: "R " + this.creditHealthInfo?.grossIncome
      });
      this.modalService.open(this.updateIncomeModel, this.modalOptions);
    }
  }

  enableUpdateIncome() {
    var regexPatternIncome = /^R\d+/;
    var income = this.updateIncomeForm.value.GrossIncome.toString().replace(/\s/g, "");
    this.UpdateIncomeDisabled = false;

    if (this.updateIncomeForm.value.GrossIncome.toString().trim() === 'R' || !(regexPatternIncome.test(income))) {
      this.updateIncomeForm.patchValue({
        GrossIncome: ''
      });
      this.UpdateIncomeDisabled = true;
    }
  }

  updateGrossIncome() {
    this.updateIncomeErrorMsg = '';
    if (this.updateIncomeForm.invalid) {
      this.updateIncomeForm.markAllAsTouched();
      return;
    }

    if (this.toNumber(this.updateIncomeForm.value.GrossIncome) >= 0) {
      this.updateIncomeForm.value.GrossIncome = parseFloat(this.toNumber(this.updateIncomeForm.value.GrossIncome));
    }
    this.userService.updateGrossIncome(this.updateIncomeForm.value).subscribe({
        next: (data: any) => {
      this.modalService.dismissAll();
      this.updateLoad();
      this.getDebtConsolidationOnIncomeUpdate();
    },
      error: (err: HttpErrorResponse) => {
        this.updateIncomeErrorMsg = err.error;
      }});
  }
  getDebtConsolidationOnIncomeUpdate() {
    this.userService.getDebtConsolidation().subscribe({
        next: (data: any) => {
      sessionStorage.removeItem('loadDebtIncomeInfo');
    }, error: (err: HttpErrorResponse) => {
    }});
  }

  toNumber(val: any) {
    val = val || '';
    const valArr = val.toString().split('');
    const valFiltered = valArr.filter((x: number) => !isNaN(x));
    const valProcessed = valFiltered.join('').trim();
    return valProcessed;
  }

  updateLoad() {
    var loadData = sessionStorage.getItem('load');
    const param = { Year: this.creditReportYear, Month: this.creditReportMonth };
    sessionStorage.removeItem('loadProductsQualify');
    sessionStorage.removeItem('loadDebtIncomeInfo');

    this.dashboardService.creditHealthInfo(param).subscribe({
        next: (data: any) => {
      sessionStorage.setItem('loadAccountCreditHealthInfo', JSON.stringify(data));
      sessionStorage.setItem('loadCreditHealthInfo', JSON.stringify(data));
      this.creditHealthInfo = data.creditHealthInfo;
      this.dashboardService.GetDebtToIncomeInfo(param).subscribe({
        next: (debtData: any) => {
        sessionStorage.setItem('loadDebtToIncomeInfo', JSON.stringify(debtData));
        if (loadData != null) {
          var loadJson = JSON.parse(loadData);
          loadJson.creditHealthInfo = data;
          loadJson.debtToIncomeInfo = debtData;
          sessionStorage.setItem('load', JSON.stringify(loadJson));
        }
      },
        error: (err: HttpErrorResponse) => {
        }});



    }, error: (err: HttpErrorResponse) => { }});

  }

  callbackPopup() {

    this.callbackSuccessMsg = '';
    this.callbackErrorMsg = '';

    this.modalService.open(this.callbackConfirmationModel, this.modalOptions);
  }
  leadCallback() {
    if(this.isDcCtaVisible){
         var params= { Action: 1 , ProductType:"dc"};
         this.nudgeService.upsertNudgeDate(params).subscribe((data: any) => {
    
        });
    }
    this.callbackErrorMsg = '';
    this.callbackSuccessMsg = '';
    this.closeCallMeBackPopupButtonName = "btn_DebtConsolidationCallMe_High_Dashboard_Closed"
    const param = {
      CampaignSource: 'btn_leadGen_consolidateLoan_callBack_popUp_yes_creditReport',
      Referrer: 'Justmoney',
      WebSource: 'CreditSav_Solution',
      SessionId: sessionStorage.getItem('sessionId')
    };
    this.communicationService.leadCallbackSource(param).subscribe({
        next: (data: any) => {
      $(".txthd").hide();
      $(".modal-footer").hide();
      this.callbackSuccessMsg == '';
      this.callbackSuccessMsg = 'Our coach will contact you shortly.';
      this.modalService.dismissAll();
      this.modalService.open(this.callbackSuccessModel, this.modalOptions)
    }, error: (err: HttpErrorResponse) => {
      this.callbackErrorMsg = 'Our coach will contact you shortly.';
      this.callBackErrorDebt = 'Our coach will contact you shortly.';
      this.modalService.dismissAll();
      this.modalService.open(this.callbackSuccessModel, this.modalOptions)
    }});
  }

  getProductsQualify() {
    var loadProductsQualifyData = sessionStorage.getItem('loadProductsQualify');
   

    if (loadProductsQualifyData != null) {
      var data = JSON.parse(loadProductsQualifyData);
      if (data != null) {
        this.productsQualifyResponse = data;
        let dcStatus = data.dcResponse;
        this.isDcCtaVisible = dcStatus?.criteria == 'no-yes'
      }
    }
  }
}
